// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-compliance-advice{border-bottom:2px solid #dfa51d;background:#e0d58c;color:#000;border-radius:2px;margin-bottom:2px;display:inline-block;word-break:break-word}.c-compliance-advice--with-popover:hover{background:#846b34}.c-compliance-advice__reason{font-weight:700}", ""]);
// Exports
module.exports = exports;
